export default {
    apiHost: 'https://api.tomatolearn.com',
    studentHost: 'https://student.tomatolearn.com',
    defaultOrgId: 3
}
